var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnrampsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6598 11.4581C24.129 11.9499 24.1106 12.729 23.6188 13.1982L14.588 21.8135C14.1122 22.2675 13.3636 22.2672 12.8881 21.8128L8.38045 17.5051C7.88903 17.0355 7.87135 16.2564 8.34097 15.765C8.81059 15.2736 9.58967 15.2559 10.0811 15.7255L13.7392 19.2213L21.9197 11.4171C22.4115 10.9479 23.1906 10.9663 23.6598 11.4581Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.46153C8.52291 2.46153 2.46154 8.52289 2.46154 16C2.46154 23.477 8.52291 29.5384 16 29.5384C23.4771 29.5384 29.5385 23.477 29.5385 16C29.5385 8.52289 23.4771 2.46153 16 2.46153ZM0 16C0 7.16343 7.16344 0 16 0C24.8366 0 32 7.16343 32 16C32 24.8365 24.8366 31.9999 16 31.9999C7.16344 31.9999 0 24.8365 0 16Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnrampsuccess);
export default __webpack_public_path__ + "static/media/onrampsuccess.95f00085edd843aaafe9652fcba82d46.svg";
export { ForwardRef as ReactComponent };